module.exports = __webpack_public_path__ + "img/ic-alert.249a5180.png";